import dynamic from 'next/dynamic';

export const FileViewer = dynamic(() => import('./FileViewer'), {
  ssr: false
});
